export default Object.freeze({
  DEVICE_TABLE: 'deviceTable',
  PROJECT_TABLE: 'projectTable',
  USER_TABLE: 'userTable',
  SHIPMENT_TABLE: 'shipmentTable'
});
